import { defineTransform } from "../transform";

defineTransform("update_property", "create_object", (op1, op2, side) => op1);

// If a property is updated on the same object that is deleted then the
// delete wins.
defineTransform("update_property", "delete_object", (op1, op2, side) => {
  if (op1.p[0] !== op2.p[0]) return op1;
  if (op1.p[1] !== op2.p[1]) return op1;

  // Must be the same node, so only keep the previous delete.
  return;
});

// If update op1 is made after op2.
defineTransform("update_property", "update_property", (op1, op2, side) => {
  // Both are attempting to update the same object & field.
  if (op1.p.toString() === op2.p.toString()) {
    // Updates are identical, so second operation is never needed.
    if (op1.cp === op2.cp && op1.dp === op2.dp) {
      return;
    }

    // For right side, second writer overwrites first.
    if (side === "right") {
      // Transform the update to happen after the previous update.
      return { p: op1.p.slice(), cp: op1.cp, dp: op2.cp };
    } else {
      return;
    }
  }

  // op1 and op2 are for different properties, so are independent.
  return op1;
});

defineTransform("update_property", "stack_create", (op1, op2, side) => op1);
defineTransform("update_property", "stack_delete", (op1, op2, side) => op1);
